import { useCallback } from "react";
import { connect } from "react-redux";

import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import TittleLine from "../../../components/Common/TittleLine";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import Pagination from "../../../components/CustomTable/Pagination";
import ModalVisualizadorDocumentos from "../components/ModalVisualizadorDocumentos";

import BusquedaValidacionesHojaQXForm from "../components/BusquedaValidacionesHojaQXForm";
import ModalAnexosValidaciones from "../components/ModalAnexosValidaciones";
import ModalComentarios from "../components/ModalComentarios";

import useEmpresa from "../../../hooks/useEmpresa";
import useValidacionesHojaQXScreen from "../hooks/useValidacionesHojaQXScreen";
import useValidacionesHojaQXScreenTable from "../hooks/useValidacionesHojaQXScreenTable";

import HojasQuirurgicasActions from "../../../stores/hospitalizacion/hojasQuirurgicas/Actions";
import PrestadorActions from "../../../stores/prestador/Actions";

const ValidacionesHojaQXScreen = (props) => {
  const empresa = useEmpresa();

  const {
    formData,
    currentPage,
    totalRegistros,
    processing,
    registros,
    alertConfig,
    showAlert,
    visibleActionsMenu,
    showModalAnexos,
    anexosAMostrar,
    modalDocumentoVisible,
    documentoModal,
    showModalComentarios,
    comentariosAMostrar,
    actionsOptions,
    itemsPerPage,
    onStateChange,
    onCleanForm,
    buscarRegistros,
    handlePageChange,
    handleMenuClick,
    handleCloseModalAnexos,
    handleCloseModalComentarios,
    abrirModalDocumento,
    cerrarModalDocumento,
    setVisibleActionsMenu,
    generarRecordKey,
  } = useValidacionesHojaQXScreen({
    authUserData: props.authUserData,
    consultarEstatusHojasQX: props.consultarEstatusHojasQX,
    consultarEstatusHojasQXData: props.consultarEstatusHojasQXData,
    consultarEstatusHojasQXLoading: props.consultarEstatusHojasQXLoading,
    consultarEstatusHojasQXError: props.consultarEstatusHojasQXError,
    consultarTipoPssNoMedico: props.consultarTipoPssNoMedico,
  });

  const { columns, columnsAnexosMemo, dataAnexos } =
    useValidacionesHojaQXScreenTable({
      visibleActionsMenu,
      setVisibleActionsMenu,
      empresa,
      actionsOptions,
      handleMenuClick,
      generarRecordKey,
      abrirModalDocumento,
      anexosAMostrar,
      tipoReclamante: props.consultarTipoPssNoMedicoData?.tipoReclamante,
    });

  const handleSearch = useCallback(() => {
    buscarRegistros(1, formData);
  }, [buscarRegistros, formData]);

  return (
    <CustomLayout
      showMenuNav={true}
      footerWidth="auto"
      marginContainer="0 0 100px 0"
      testid="validaciones-hoja-qx-layout"
    >
      <Section testid="title-section">
        <TittleLine
          title="Validaciones de Hoja Quirúrgica"
          weight="bold"
          testid="validaciones-hoja-qx-title"
        />
      </Section>

      <Section testid="search-form-section">
        <BusquedaValidacionesHojaQXForm
          numeroIngreso={formData.numeroIngreso}
          fechaInicio={formData.fechaInicio}
          fechaFin={formData.fechaFin}
          onStateChange={onStateChange}
          onSearch={handleSearch}
          onClean={onCleanForm}
          isLoading={processing}
          testid="busqueda-validaciones-form"
        />
      </Section>

      <Section testid="table-section">
        <CustomTable
          columns={columns}
          dataSource={registros}
          pageSize={itemsPerPage}
          width="200%"
          testid="validaciones-table"
        />
      </Section>

      <CustomSeparator height={"20px"} testid="separator-table" />

      {totalRegistros > 0 && (
        <Section testid="pagination-section">
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalRegistros}
            onPageChange={handlePageChange}
            disabled={processing || props.consultarEstatusHojasQXLoading}
            testid="pagination"
          />
        </Section>
      )}

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} testid="custom-alert" />
      </CheckRender>

      <ModalAnexosValidaciones
        isOpen={showModalAnexos}
        onClose={handleCloseModalAnexos}
        anexosAMostrar={anexosAMostrar}
        columnsAnexos={columnsAnexosMemo}
        dataAnexos={dataAnexos}
      />

      <ModalVisualizadorDocumentos
        visible={modalDocumentoVisible}
        documento={documentoModal}
        onClose={cerrarModalDocumento}
      />

      <ModalComentarios
        isOpen={showModalComentarios}
        onClose={handleCloseModalComentarios}
        comentariosAMostrar={comentariosAMostrar}
      />
    </CustomLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    authUserData: state.auth.authUserData,
    consultarEstatusHojasQXData: state.hospitalizacion.consultarEstatusHojasQXData,
    consultarEstatusHojasQXLoading: state.hospitalizacion.consultarEstatusHojasQXLoading,
    consultarEstatusHojasQXError: state.hospitalizacion.consultarEstatusHojasQXError,
    consultarTipoPssNoMedicoData: state.prestador.consultarTipoPssNoMedicoData,
  };
};

const mapDispatchToProps = {
  consultarEstatusHojasQX: HojasQuirurgicasActions.consultarEstatusHojasQX,
  consultarTipoPssNoMedico: PrestadorActions.consultarTipoPssNoMedico,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ValidacionesHojaQXScreen);

